import { GridColumn } from '@shared/modules/grid/abstractions';
import { FilterTypes } from '../helpers/enums/filter-type.enum';
import { ColumnFilterLoader } from './column-filter-loader';
import { Filter } from '../helpers/types/filter.type';

export class FilterTypesDefinition extends ColumnFilterLoader {
  protected column: GridColumn;
  protected filter: Filter;

  constructor(filterColumn: GridColumn) {
    super(
      (filterColumn.filterableColumn &&
        filterColumn.filterableColumn.oDataPath) ??
        filterColumn.key
    );
    this.column = filterColumn;
    this.filter = filterColumn.filterableColumn!;
  }

  get isCombobox(): boolean {
    return this.filter.type === FilterTypes.Combobox;
  }

  get isDropdown(): boolean {
    return this.filter.type === FilterTypes.Dropdown;
  }

  get isTextfield(): boolean {
    return this.filter.type === FilterTypes.TextField;
  }

  get isSlider(): boolean {
    return this.filter.type === FilterTypes.Slider;
  }

  get isDatepicker(): boolean {
    return this.filter.type === FilterTypes.Datepicker;
  }
}
